export default __webpack_public_path__ + "assets/webgl/LargeFire_sheet.6d95cfe0.jpg";